(function () {
  'use strict';

  var METAFIELD_KEYS = [
    'oem', 'رقم القطعة', 'رقم القطعة (oem)',
    'sku', 'رقم الصنف', 'رقم الصنف (sku)',
    'material', 'المادة',
    'dimensions', 'الأبعاد',
    'weight', 'الوزن', 'weight_spec',
    'color', 'اللون', 'color_spec',
    'warranty', 'الضمان',
    'origin', 'بلد المنشأ',
    'brand', 'brand_name', 'العلامة التجارية',
    'compatibility', 'التوافق',
    'condition', 'الحالة',
    'part_type', 'النوع'
  ];

  var LABEL_MAP = {
    'oem': 'رقم القطعة (OEM)',
    'sku': 'رقم الصنف (SKU)',
    'material': 'المادة',
    'dimensions': 'الأبعاد',
    'weight': 'الوزن',
    'warranty': 'الضمان',
    'color': 'اللون',
    'origin': 'بلد المنشأ',
    'brand': 'العلامة التجارية',
    'condition': 'الحالة',
    'compatibility': 'التوافق',
    'المادة': 'المادة',
    'الأبعاد': 'الأبعاد',
    'الوزن': 'الوزن',
    'الضمان': 'الضمان',
    'اللون': 'اللون',
    'بلد المنشأ': 'بلد المنشأ',
    'العلامة التجارية': 'العلامة التجارية',
    'الحالة': 'الحالة',
    'التوافق': 'التوافق',
    'رقم القطعة': 'رقم القطعة (OEM)',
    'رقم الصنف': 'رقم الصنف (SKU)',
    'الموديل': 'الموديل',
    'النوع': 'النوع',
    'الفئة': 'الفئة'
  };

  function sanitize(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str));
    return d.innerHTML;
  }

  function resolveLabel(raw) {
    var key = raw.trim().toLowerCase();
    return LABEL_MAP[key] || LABEL_MAP[raw.trim()] || raw.trim();
  }

  function isMetafieldKey(raw) {
    var key = raw.trim().toLowerCase();
    return METAFIELD_KEYS.some(function (k) { return k === key; });
  }

  function parseSpecs(text) {
    if (!text) return [];
    var specs = [], seen = {};
    var lines = text.replace(/<br\s*\/?>/gi, '\n').split(/[\n\r]+/);
    var RE = /^([^:：]{1,60})[：:](.+)$/;
    lines.forEach(function (line) {
      var clean = line.trim();
      if (!clean) return;
      var match = clean.match(RE);
      if (!match) return;
      var rawKey = match[1].trim();
      var value = match[2].trim();
      if (!value || /^https?:\/\//i.test(value) || /<[a-z]/i.test(value)) return;
      if (rawKey.length < 2 || rawKey.split(' ').length > 6) return;
      if (isMetafieldKey(rawKey)) return;
      var dk = rawKey.toLowerCase();
      if (seen[dk]) return;
      seen[dk] = true;
      specs.push({ label: resolveLabel(rawKey), value: value });
    });
    return specs;
  }

  function applyRowStyles(tbody) {
    tbody.querySelectorAll('.spec-row').forEach(function (row, i) {
      row.classList.remove('spec-row--even', 'spec-row--odd');
      row.classList.add(i % 2 === 0 ? 'spec-row--even' : 'spec-row--odd');
      row.style.animationDelay = (i * 60) + 'ms';
      row.classList.add('spec-row--animate');
    });
  }

  function initDragToScroll(wrapper, container) {
    var isDown = false;
    var startX;
    var startY;
    var scrollLeft;
    var isDragging = false;

    wrapper.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return; // Left click only
      isDown = true;
      startX = e.pageX - wrapper.offsetLeft;
      startY = e.pageY - wrapper.offsetTop;
      scrollLeft = wrapper.scrollLeft;
      isDragging = false;
    });

    wrapper.addEventListener('mouseleave', function () {
      if (isDown && isDragging) {
        wrapper.classList.remove('active-dragging');
        wrapper.style.cursor = 'grab';
      }
      isDown = false;
      isDragging = false;
    });

    wrapper.addEventListener('mouseup', function () {
      if (isDown && isDragging) {
        wrapper.classList.remove('active-dragging');
        wrapper.style.cursor = 'grab';
        wrapper.classList.add('just-dragged');
        setTimeout(function () {
          wrapper.classList.remove('just-dragged');
        }, 50);
      }
      isDown = false;
      isDragging = false;
    });

    wrapper.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var x = e.pageX - wrapper.offsetLeft;
      var y = e.pageY - wrapper.offsetTop;
      var walkX = x - startX;
      var walkY = y - startY;

      if (!isDragging && (Math.abs(walkX) > 5 || Math.abs(walkY) > 5)) {
        isDragging = true;
        wrapper.classList.add('active-dragging');
        wrapper.style.cursor = 'grabbing';
      }

      if (isDragging) {
        e.preventDefault();
        var isRTL = window.getComputedStyle(wrapper).direction === 'rtl';
        if (isRTL) {
          wrapper.scrollLeft = scrollLeft - walkX;
        } else {
          wrapper.scrollLeft = scrollLeft + walkX;
        }
      }
    });

    wrapper.addEventListener('click', function (e) {
      if (wrapper.classList.contains('just-dragged')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    wrapper.style.cursor = 'grab';
  }

  function initScrollIndicator(container) {
    var wrapper = container.querySelector('.specs-table-wrapper');
    if (!wrapper) return;

    function updateArrow() {
      var scrollWidth = wrapper.scrollWidth;
      var clientWidth = wrapper.clientWidth;
      var maxScroll = scrollWidth - clientWidth;

      if (maxScroll > 5) {
        container.classList.add('has-scroll-hint');
        var scrollLeft = wrapper.scrollLeft;
        var isRTL = window.getComputedStyle(wrapper).direction === 'rtl';

        var isEnd = false;
        if (isRTL) {
          isEnd = (Math.abs(scrollLeft) >= maxScroll - 12);
        } else {
          isEnd = (scrollLeft >= maxScroll - 12);
        }

        if (isEnd) {
          container.classList.add('scroll-reached-end');
        } else {
          container.classList.remove('scroll-reached-end');
        }
      } else {
        container.classList.remove('has-scroll-hint');
      }
    }

    wrapper.addEventListener('scroll', updateArrow);
    window.addEventListener('resize', updateArrow);

    updateArrow();
    setTimeout(updateArrow, 250);
  }

  function initAllSpecsTables() {
    // 1. Process fallback description specs for metafield containers
    document.querySelectorAll('.specs-section[data-desc]').forEach(function (container) {
      if (container.classList.contains('specs-fallback-processed')) return;
      container.classList.add('specs-fallback-processed');

      var tbody = container.querySelector('tbody');
      if (!tbody) return;
      var hasMetafields = container.getAttribute('data-has-metafields') === 'true';
      var extras = parseSpecs(container.getAttribute('data-desc') || '');
      if (!hasMetafields && !extras.length) return;
      if (extras.length) {
        tbody.insertAdjacentHTML('beforeend', extras.map(function (row) {
          return '<tr class="spec-row">' +
            '<th class="spec-label" scope="row">' + sanitize(row.label) + '</th>' +
            '<td class="spec-value">' + sanitize(row.value) + '</td>' +
            '</tr>';
        }).join(''));
      }
      applyRowStyles(tbody);
      container.style.setProperty('display', 'block');
    });

    // 2. Initialize interactive behaviors for all specs sections
    document.querySelectorAll('.specs-section').forEach(function (container) {
      if (container.classList.contains('specs-table-initialized')) return;
      container.classList.add('specs-table-initialized');

      var wrapper = container.querySelector('.specs-table-wrapper');
      if (wrapper) {
        initDragToScroll(wrapper, container);
        initScrollIndicator(container);
      }

      // Style even/odd rows for dynamic description tables if not styled yet
      var tbody = container.querySelector('tbody');
      if (tbody && !container.hasAttribute('data-desc')) {
        applyRowStyles(tbody);
      }
    });
  }

  window.initAllSpecsTables = initAllSpecsTables;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSpecsTables);
  } else {
    initAllSpecsTables();
  }
})();
